<template>
  <portal to="modals">
    <div v-if="show && file" class="modal-root" @click.self="close">
      <div class="modal-content">
        <button @click="close" class="modal-close-button" title="닫기">
          <span class="material-icons">close</span>
        </button>
        <div class="file-info">
          <span class="file-name">{{ file.name }}</span>
          <span class="file-size">{{ formatSize(file.size) }}</span>
        </div>
        <div v-if="file.blobUrl">
          <iframe :src="file.blobUrl" width="600" height="700" style="border:none;"></iframe>
        </div>
        <div v-else>
          <div class="file-desc">파일 미리보기를 불러올 수 없습니다.</div>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: 'FilePreviewModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      fileText: ''
    }
  },
  computed: {
    isPdf() {
      return this.file && this.file.type === 'application/pdf'
    },
    isTextFile() {
      // txt, csv 등 텍스트 파일
      return this.file && ((this.file.type && this.file.type.startsWith('text/')) || (this.file.name && this.file.name.match(/\.(csv|log)$/i)))
    },
    iconUrl() {
      // 파일 확장자별 아이콘 (간단 예시)
      if (!this.file || !this.file.name) return '/icons/file.png'
      const ext = this.file.name.split('.').pop().toLowerCase()
      if (ext === 'pdf') return '/icons/pdf.png'
      if (['doc','docx'].includes(ext)) return '/icons/word.png'
      if (['xls','xlsx'].includes(ext)) return '/icons/excel.png'
      if (['ppt','pptx'].includes(ext)) return '/icons/ppt.png'
      if (['hwp'].includes(ext)) return '/icons/hwp.png'
      return '/icons/file.png'
    },
    formatSize() {
      return (size) => {
        if (!size) return ''
        if (size < 1024) return size + 'B'
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + 'KB'
        return (size / 1024 / 1024).toFixed(1) + 'MB'
      }
    }
  },
  watch: {
    show(newVal) {
      if (newVal && this.isTextFile) {
        this.readTextFile()
      }
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    readTextFile() {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.fileText = e.target.result
      }
      reader.readAsText(this.file)
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.modal-root {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  pointer-events: all;
}
.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: #fff;
  border-radius: 10px;
  padding: 32px 24px 24px 24px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.18);
}
.modal-close-button {
  position: absolute;
  top: -40px;
  right: 0;
  padding: 8px;
  color: #fff;
  cursor: pointer;
  background: none;
  border: none;
  font-size: 24px;
  z-index: 10;
}
.modal-close-button:hover {
  opacity: 0.7;
}
.file-info {
  margin-bottom: 16px;
  font-size: 15px;
  color: #444;
  display: flex;
  gap: 16px;
  align-items: center;
}
.file-name {
  font-weight: bold;
}
.file-size {
  color: #888;
  font-size: 13px;
}
.file-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}
.file-desc {
  text-align: center;
  color: #888;
  font-size: 15px;
}
.file-text {
  max-width: 600px;
  max-height: 600px;
  overflow: auto;
  background: #f8f8f8;
  border-radius: 6px;
  padding: 16px;
  font-size: 15px;
  color: #222;
}
.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style> 